export default __webpack_public_path__ + "081e0f174bf1cd185720cac4dcdc3301.png";